import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import img from "../../Assets/home/gallry.png";
const Gallery = () => {
  //State to store all the gallery photos of a branch
  const [allGallery, setAllGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  //Function to fetch all the gallery photos of a branch
  const showAllgalleryData = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/gallery/getGallery/674586f39aa6780fb2688685`,
      headers: {},
    };

    setLoading(true)
    axios
      .request(config)
      .then((response) => {
        setAllGallery(response.data.data);
        setLoading(false)
      })
      .catch((error) => {
        console.log(error);
        setLoading(false)
      }).finally(() => {
        setLoading(false)
      });
  };


  useEffect(() => {
    showAllgalleryData();
  }, []);
  return (
    <div className="m-6 md:m-16">
      <p className="text-center italic text-[#FF8F61]">Gallery</p>
      <h1 className="text-[#202020]  text-center text-3xl md:text-4xl lg:text-5xl mb-4 md:mb-6 font-serif font-bold tracking-wide">
        Our Latest Gallery
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {loading ? Array.from({ length: 3 }).map((_, ind) => {
          return (
            <div
            key={ind}
            className="animate-pulse h-80 w-full bg-[#e79d68]"></div>
          )
        }) : allGallery?.map((gallery, index) => (
          <img src={gallery.gallery} alt="" className="w-full object-cover rounded-lg h-full" />
        ))}
      </div>
    </div>
  );
};

export default Gallery;
